<template v-if="loaded">
    <div>
        <!-- Posts -->
        <div v-if="headers.total < 1 || !headers.total && !isFetching" :class="classes">
            <!-- <div class="heading--5">0 resultaten</div> -->
            <div class="card">
                <p>Probeer je zoekopdracht aan te passen.</p>
            </div>
        </div>
        <div v-else :class="classes">
            <!-- <div class="heading--5" v-if="!isFetching">{{ SearchResultsTitle }}</div> -->
            <template v-for="post in filteredPosts">
                <course-teaser
                    :title="post.title.rendered"
                    :link="post.link"
                    :excerpt="post.acf.course_intro"
                    :locations="getLocations(post)"
                    :price="post.acf.course_pricing"
                    :course_duration="post.acf.course_duration"
                    :date="post.date">
                </course-teaser>
            </template>
        </div>
        <!-- LOADING -->
        <div class="overview__actions">
            <div v-if="isFetching && query.page > 1">
                <svg xmlns=" w3.org xmlns:xlink=" w3.org style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="60px" height="60px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="#009B96" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                    </circle>
                </svg>
            </div>
            <button v-else-if="fetchCompleted && headers.total > 0" class="btn btn--b" @click="nextPosts" :hidden="query['page'] === headers['pages']">Meer laden</button>
        </div>
    </div>
</template>

<script>
import Icon from './Icon.vue';
import { store } from './store.js';
import CourseTeaser from './CourseTeaser.vue';

export default {
    name: 'CourseOverview',
    components: {
      Icon,
      CourseTeaser
    },
    data() {
        return {
            loaded: false,
            posts: [],
            activeParams: [],
            query: {
                page: 1,
                per_page: 12,
                _embed: 1
            },
            /**
            * This is a list of 'safe' params to use with the WP REST API query.
            * Other parameters can create conflicts.
            *
            * This array can be extended to include custom params such as taxonomies
             */
            params: [
                'context',
                'page',
                'per_page',
                'search',
                'after',
                'before',
                'exclude',
                'include',
                'offset',
                'order',
                'orderby',
                '_embed'
            ],
            headers: {},
            isFetching: false,
            fetchCompleted: false,
            store,
            overviewClass: 'overview__list'
        };
    },
    computed: {
        filteredPosts() {
            return this.posts;
        },
        classes() {
            return [
                'overview',
                this.overviewClass
            ].join(' ');
        },
        // SearchResultsTitle() {
        //     let title = '';

        //     if(this.headers.total == 1) {
        //         if(this.query['search'] && this.query['search']?.[0].length !== 0) {
        //             title = `1 resultaat voor '${this.query['search'][0]}'`;
        //         } else {
        //             title = `1 resultaat`;
        //         }
        //     } else {
        //         if(this.query['search'] && this.query['search']?.[0].length !== 0) {
        //             title = `${this.headers.total} resultaten voor '${this.query['search'][0]}'`;
        //         } else {
        //             title = `${this.headers.total} resultaten`;
        //         }
        //     }

        //     return title;
        // }
    },
    methods: {
        async fetchData() {
            this.loaded = true;
            this.isFetching = true;

            // Order by relevance if a search term exists
            if(this.query['search'] && this.query['search']?.[0].length !== 0) {
                this.query.orderby = 'relevance';
            }

            // Create a safe WP Query using permitted params
            let safeQuery = {};

            Object.keys(this.query).map(p => {
            if (this.params.includes(p))
                safeQuery[p] = this.query[p];
            });

            // Build the url query
            let url = [
                window.SITE_URL,
                this.store.endpoints['course'],
                '?',
                this.getUrlParams(safeQuery)
            ].join('');

            try {
                const response = await fetch(url);

                if (response.ok) {
                    const data = await response.json();

                    // Map headers from response. Headers are used to determine if there are additional pages surrounding a query.
                    let headers = {
                        total: 'X-WP-Total',
                        pages: 'X-WP-TotalPages',
                        link: 'Link'
                    };

                    Object.keys(headers).forEach((key) => {
                        const header = response.headers.get(headers[key]);
                        const value = isNaN(header) ? header : parseInt(header) || 0;
                        headers[key] = value;
                    });

                    this.headers = headers;

                    this.$nextTick(() => {
                        this.posts = [...this.posts,...data];
                        this.fetchCompleted = true;
                        this.isFetching = false;
                    });
                }
            } catch (error) {
                this.handleError(error);
            }
        },
        getState(query = false) {
            query = (query) ? query : this.buildJsonQuery(window.location.search);

            Object.keys(query).map(key => {
                this.query[key] = query[key]
            });
            Object.values(query).map(value => {
                this.activeParams.push(value.toString());
            });
            return this;
        },
        getUrlParams(query) {
            return new URLSearchParams(query).toString();

        },
        buildJsonQuery(query) {
            if (query === '') return false;
            let params = new URLSearchParams(query);
            let q = {};

            // Set keys in object and get values, convert to number (!NaN)
            params.forEach(function(value, key) {
                let k = key;

                if (!q.hasOwnProperty(k))
                q[k] = params.getAll(key).map(value => {
                    return value;
                });
            });
            return q;
        },
        handleError(response) {
            // eslint-disable-next-line no-undef
            if (process.env.NODE_ENV === 'development') {
                console.dir(response);
            }

            this.isFetching = false;
        },
        nextPosts(event) {
            event.preventDefault();

            this.query['page']++;
            this.fetchData();
        },
        getLocations(post) {
            const locations = post.acf.course_locations;

            if(locations) {
                const map1 = locations.map(x => {
                    return x.course_location_place;
                });

                return map1.join(', ');
            }
        }

    },
    mounted: function() {
        this.getState();
        this.fetchData();
    },
};
</script>

<style lang="scss">
</style>
